import { render } from "./Poyra.vue?vue&type=template&id=1b7aacba"
import script from "./Poyra.vue?vue&type=script&lang=js"
export * from "./Poyra.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__